import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, withCtx as _withCtx, Fragment as _Fragment, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/images/new-content-login.png'
import _imports_1 from '@/images/logo-login.png'


const _withScopeId = n => (_pushScopeId("data-v-1e78dae4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "box" }
const _hoisted_2 = {
  key: 0,
  class: "box-thumb"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "hero-image-fade",
  preview: false
}, null, -1))
const _hoisted_4 = /*#__PURE__*/_createStaticVNode("<div class=\"hero-content\" data-v-1e78dae4><h1 class=\"hero-fade hero-fade-1\" data-v-1e78dae4> Assinatura eletrônica <span style=\"color:#0664ce;\" data-v-1e78dae4>segura </span> e <span style=\"color:#56c24d;\" data-v-1e78dae4>confiável</span></h1><p class=\"hero-fade hero-fade-2\" data-v-1e78dae4> Tecnologia e segurança para simplificar seu dia a dia e proteger o que importa. </p><div class=\"hero-features\" data-v-1e78dae4><span class=\"hero-fade hero-fade-3\" data-v-1e78dae4>🔒 Segurança ponta a ponta</span><span class=\"hero-fade hero-fade-4\" data-v-1e78dae4>👥 Múltiplos signatários</span><span class=\"hero-fade hero-fade-5\" data-v-1e78dae4>📄 Validade jurídica</span></div></div>", 1)
const _hoisted_5 = [
  _hoisted_3,
  _hoisted_4
]
const _hoisted_6 = { class: "box-content" }
const _hoisted_7 = {
  key: 0,
  class: "content-account"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("section", { class: "content-header" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "header-logo" }, [
    /*#__PURE__*/_createElementVNode("img", {
      src: _imports_1,
      alt: "Acesso ao Sistema",
      preview: false
    })
  ])
], -1))
const _hoisted_9 = { class: "account-header" }
const _hoisted_10 = { class: "account-form" }
const _hoisted_11 = { class: "switch" }
const _hoisted_12 = { class: "switch-company" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, [
  /*#__PURE__*/_createElementVNode("p", null, "Envie e gerencie documentos para o seu negócio.")
], -1))
const _hoisted_14 = { class: "switch-person" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, [
  /*#__PURE__*/_createElementVNode("p", null, "Para uso pessoal e assinatura de documentos individuais.")
], -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "form-section-label" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Dados da Empresa")
], -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "form-section-label" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Responsável pela Conta")
], -1))
const _hoisted_18 = { class: "form-terms" }
const _hoisted_19 = /*#__PURE__*/_createTextVNode(" Concordo com os ")
const _hoisted_20 = /*#__PURE__*/_createTextVNode(" e ")
const _hoisted_21 = /*#__PURE__*/_createTextVNode(". ")
const _hoisted_22 = { class: "form-action" }
const _hoisted_23 = /*#__PURE__*/_createTextVNode(" Criar conta ")
const _hoisted_24 = { class: "action-go-login" }
const _hoisted_25 = /*#__PURE__*/_createTextVNode(" Já tem uma conta? ")
const _hoisted_26 = {
  key: 1,
  class: "content-success"
}
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "success-title" }, "Sua conta foi criada com sucesso!", -1))
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "success-subtitle" }, "Enviamos um link de verificação. Acesse seu e-mail para verificar a sua conta!", -1))
const _hoisted_29 = /*#__PURE__*/_createTextVNode("Ir para o login")
const _hoisted_30 = {
  key: 0,
  class: "content-footer"
}
const _hoisted_31 = {
  key: 0,
  class: "terms"
}
const _hoisted_32 = {
  key: 1,
  class: "policy"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_switch = _resolveComponent("a-switch")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_input_password = _resolveComponent("a-input-password")!
  const _component_a_checkbox = _resolveComponent("a-checkbox")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_CheckCircleFilled = _resolveComponent("CheckCircleFilled")!
  const _component_Footer = _resolveComponent("Footer")!
  const _component_ModalTerms = _resolveComponent("ModalTerms")!
  const _component_ModalPolicy = _resolveComponent("ModalPolicy")!
  const _component_a_modal = _resolveComponent("a-modal")!
  const _directive_maska = _resolveDirective("maska")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    (!_ctx.isMobile)
      ? (_openBlock(), _createElementBlock("section", _hoisted_2, _hoisted_5))
      : _createCommentVNode("", true),
    _createElementVNode("section", _hoisted_6, [
      _createElementVNode("div", {
        class: _normalizeClass(["account-card", { 'is-person': _ctx.typeAccountPerson, 'is-company': _ctx.typeAccountCompany }])
      }, [
        (!_ctx.isSuccessCreateAccount)
          ? (_openBlock(), _createElementBlock("section", _hoisted_7, [
              _hoisted_8,
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("h2", null, "Criação de conta: " + _toDisplayString(_ctx.typeAccountCompany ? 'Pessoa Jurídica' : 'Pessoa Física'), 1)
              ]),
              _createElementVNode("div", _hoisted_10, [
                _createVNode(_component_a_form, {
                  layout: "vertical",
                  ref: "formRef",
                  class: "form"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_11, [
                      _createElementVNode("div", _hoisted_12, [
                        _createElementVNode("div", null, [
                          _createVNode(_component_a_switch, {
                            checked: _ctx.typeAccountCompany,
                            "onUpdate:checked": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.typeAccountCompany) = $event)),
                            "checked-children": "Pessoa Jurídica",
                            "un-checked-children": "Pessoa Jurídica",
                            onChange: _ctx.checkTypeCompany
                          }, null, 8, ["checked", "onChange"])
                        ]),
                        _hoisted_13
                      ]),
                      _createElementVNode("div", _hoisted_14, [
                        _createElementVNode("div", null, [
                          _createVNode(_component_a_switch, {
                            checked: _ctx.typeAccountPerson,
                            "onUpdate:checked": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.typeAccountPerson) = $event)),
                            "checked-children": "Pessoa Física",
                            "un-checked-children": "Pessoa Física",
                            onChange: _ctx.checkTypePerson
                          }, null, 8, ["checked", "onChange"])
                        ]),
                        _hoisted_15
                      ])
                    ]),
                    (_ctx.typeAccountCompany)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _hoisted_16,
                          _createVNode(_component_a_form_item, null, {
                            default: _withCtx(() => [
                              _withDirectives(_createVNode(_component_a_input, {
                                value: _ctx.formAccount.cnpj,
                                "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.formAccount.cnpj) = $event)),
                                placeholder: "CNPJ *",
                                size: "large"
                              }, null, 8, ["value"]), [
                                [_directive_maska, '##.###.###/####-##']
                              ])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_a_form_item, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_a_input, {
                                value: _ctx.formAccount.nomeFantasia,
                                "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.formAccount.nomeFantasia) = $event)),
                                placeholder: "Nome Fantasia *",
                                size: "large"
                              }, null, 8, ["value"])
                            ]),
                            _: 1
                          }),
                          _hoisted_17
                        ], 64))
                      : _createCommentVNode("", true),
                    _createVNode(_component_a_form_item, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_input, {
                          value: _ctx.formAccount.name,
                          "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.formAccount.name) = $event)),
                          placeholder: "Nome Completo *",
                          size: "large"
                        }, null, 8, ["value"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_form_item, null, {
                      default: _withCtx(() => [
                        _withDirectives(_createVNode(_component_a_input, {
                          value: _ctx.formAccount.cpf,
                          "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.formAccount.cpf) = $event)),
                          placeholder: "CPF *",
                          size: "large"
                        }, null, 8, ["value"]), [
                          [_directive_maska, '###.###.###-##']
                        ])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_form_item, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_input, {
                          value: _ctx.formAccount.email,
                          "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.formAccount.email) = $event)),
                          placeholder: "E-mail *",
                          size: "large"
                        }, null, 8, ["value"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_form_item, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_input_password, {
                          value: _ctx.formAccount.password,
                          "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.formAccount.password) = $event)),
                          placeholder: "*******",
                          size: "large"
                        }, null, 8, ["value"])
                      ]),
                      _: 1
                    }),
                    _createElementVNode("div", _hoisted_18, [
                      _createVNode(_component_a_checkbox, {
                        onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.AcceptTerms())),
                        class: "spaceRight"
                      }),
                      _createElementVNode("span", null, [
                        _hoisted_19,
                        _createElementVNode("a", {
                          onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.showModal(1))),
                          class: "text-link"
                        }, "Termos de Uso"),
                        _hoisted_20,
                        _createElementVNode("a", {
                          onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.showModal(2))),
                          class: "text-link"
                        }, "Política de Privacidade"),
                        _hoisted_21
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_22, [
                      _createVNode(_component_a_button, {
                        type: "primary",
                        size: "larger",
                        class: "btn-action-certificata",
                        style: {"width":"40%","max-width":"300px"},
                        onClick: _ctx.createAccount,
                        disabled: this.typeAccount === 0
                      }, {
                        default: _withCtx(() => [
                          _hoisted_23
                        ]),
                        _: 1
                      }, 8, ["onClick", "disabled"]),
                      _createElementVNode("span", _hoisted_24, [
                        _hoisted_25,
                        _createElementVNode("a", {
                          onClick: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.setLoginAccount && _ctx.setLoginAccount(...args)))
                        }, "Faça login!")
                      ])
                    ])
                  ]),
                  _: 1
                }, 512)
              ])
            ]))
          : _createCommentVNode("", true),
        (_ctx.isSuccessCreateAccount)
          ? (_openBlock(), _createElementBlock("section", _hoisted_26, [
              _createVNode(_component_CheckCircleFilled, { class: "success-ic" }),
              _hoisted_27,
              _hoisted_28,
              _createVNode(_component_a_button, {
                type: "primary",
                class: "btn-action-certificata",
                onClick: _ctx.setLoginAccount
              }, {
                default: _withCtx(() => [
                  _hoisted_29
                ]),
                _: 1
              }, 8, ["onClick"])
            ]))
          : _createCommentVNode("", true)
      ], 2),
      (!_ctx.isCreateAccount && !_ctx.isMobile)
        ? (_openBlock(), _createElementBlock("section", _hoisted_30, [
            _createVNode(_component_Footer)
          ]))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_component_a_modal, {
      visible: _ctx.visible,
      "onUpdate:visible": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.visible) = $event)),
      width: "1000px",
      onOk: _ctx.handleOk,
      footer: null
    }, {
      default: _withCtx(() => [
        (_ctx.textVisible == 1)
          ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
              _createVNode(_component_ModalTerms)
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_32, [
              _createVNode(_component_ModalPolicy)
            ]))
      ]),
      _: 1
    }, 8, ["visible", "onOk"])
  ]))
}